import React from 'react';
import { Table, Tag, Card, Divider, Typography } from 'antd';
import dayjs from 'dayjs';

const { Text } = Typography;

interface InventoryBatch {
    id: number;
    batch_number: string;
    warehouse_name: string;
    quantity_initial: number;
    quantity_remaining: number;
    unit_cost: number;
    currency: string;
    inbound_date: string;
}

interface InventorySummary {
    warehouse__name: string;
    warehouse__code: string;
    total_remaining: number;
}

interface SKUInventoryDetailsProps {
    batches?: InventoryBatch[];
    summary?: InventorySummary[];
}

export const SKUInventoryDetails: React.FC<SKUInventoryDetailsProps> = ({ batches = [], summary = [] }) => {
    const columns = [
        {
            title: '批次号',
            dataIndex: 'batch_number',
            key: 'batch_number',
        },
        {
            title: '仓库',
            dataIndex: 'warehouse_name',
            key: 'warehouse_name',
        },
        {
            title: '入库日期',
            dataIndex: 'inbound_date',
            key: 'inbound_date',
            render: (date: string) => dayjs(date).format('YYYY-MM-DD'),
            sorter: (a: any, b: any) => dayjs(a.inbound_date).unix() - dayjs(b.inbound_date).unix(),
        },
        {
            title: '单价',
            dataIndex: 'unit_cost',
            key: 'unit_cost',
            render: (val: number, record: any) => `${record.currency || '¥'} ${val.toFixed(2)}`,
        },
        {
            title: '初始数量',
            dataIndex: 'quantity_initial',
            key: 'quantity_initial',
        },
        {
            title: '剩余数量',
            dataIndex: 'quantity_remaining',
            key: 'quantity_remaining',
            render: (val: number) => (
                <Text strong style={{ color: val > 0 ? '#52c41a' : '#d9d9d9' }}>
                    {val}
                </Text>
            ),
        }
    ];

    if (!batches || batches.length === 0) {
        return <Text type="secondary">暂无批次库存信息</Text>;
    }

    return (
        <div style={{ marginTop: 16 }}>
            <Divider orientation="left">分仓库汇总</Divider>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 24 }}>
                {summary.map((item, index) => (
                    <Card key={index} size="small" style={{ width: 150 }}>
                        <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{item.warehouse__name}</div>
                        <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{item.total_remaining}</div>
                    </Card>
                ))}
            </div>

            <Divider orientation="left">库存批次明细 (FIFO)</Divider>
            <Table
                dataSource={batches}
                columns={columns}
                rowKey="id"
                size="small"
                pagination={false}
                scroll={{ y: 300 }}
            />
        </div>
    );
};
